<div class="position-absolute vw-100 vh-100 blur"></div>
<div
  class="position-absolute top-50 start-50 translate-middle bg-dark text-gray p-5 border border-darkgray rounded-2"
>
  <span class="d-flex rb-ic rb-ic-wrench fs-8xl justify-content-center align-content-center"></span>
  <br />
  <h4 class="d-flex justify-content-center">Maintenance mode</h4>
  <p>We are currently performing scheduled maintenance. We will be back shortly.</p>
</div>
